import BaseViz from './BaseViz'
import WaterfallChartChart from '../charts/WaterfallChartChart'
import WaterfallDataController from '../viz_behaviors/WaterfallDataController'
export default class WaterfallChartViz extends BaseViz {
  static defaultConfig = {
    ItemsHelper: {
      colorScale: {
        value: 'variation',
        options: ['variation'],
        nonEditable: true,
        exposed: false,
      },
    },
    AxisHelper: {
      x: {
        trimThreshold: {
          nonEditable: true,
          exposed: false,
        },
        valueFormat: {
          nonEditable: true,
          exposed: false,
        },
        unit: {
          nonEditable: true,
          exposed: false,
        },
        scale: {
          nonEditable: true,
        },
        tickMatchData: {
          nonEditable: true,
          exposed: false,
        },
        domain: {
          nonEditable: true,
        },
      },
    },
  }
  static chartClass = WaterfallChartChart
  static dataControllerClass = WaterfallDataController
}
